import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { imageBorderStyles } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

import { HeroComposition } from '../../types';
import { imageStyle, mobileImageStyle } from './styles';

const Banner: HeroComposition['Banner'] = (props) => {
  const {
    content: { imageUrl },
  } = useHeroContext();
  const { className, ...rest } = props;
  const { isMobile } = useScreen();
  const { t } = useTranslation();

  if (!imageUrl) {
    return null;
  }

  return (
    <Image
      alt={t('Common:BannerImage')}
      className={cn(
        'relative flex rounded object-cover',
        isMobile ? mobileImageStyle : imageStyle,
        imageBorderStyles({ size: '2px' }),
        className,
      )}
      layout="fill"
      src={imageUrl}
      {...rest}
    />
  );
};

export default React.memo(Banner);
